"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.answerAppBaseDataRequest = answerAppBaseDataRequest;
const app_base_source_query_1 = require("./app-base-source-query");
const MAX_QUERY_LENGTH = 16_384;
/**
 * The answer of a host page to one data request of the bridge in its frame,
 * shaped like the server answers it: the result whole or as transport pages,
 * an ETag of its revision, 304 for an unchanged window, and the status and
 * error body of each query error. `url` carries the query (`q`), the page
 * (`continuation`), the route and the language; `querySource` reads the rows.
 */
async function answerAppBaseDataRequest(input) {
    const { url } = input;
    try {
        const queryJson = url.searchParams.get('q') ?? '{}';
        if (queryJson.length > MAX_QUERY_LENGTH)
            throw new app_base_source_query_1.AppBaseSourceQueryError('APP_BASE_QUERY_INVALID', input.messages.queryTooLarge);
        const result = await input.querySource(JSON.parse(queryJson), {
            routePath: url.searchParams.get('route') ?? undefined,
            locale: url.searchParams.get('lang'),
        });
        const page = (0, app_base_source_query_1.createAppBaseSourceQueryTransportPage)(result, url.searchParams.get('continuation') ?? undefined);
        const transport = !url.searchParams.has('continuation') && page.continuation === null
            ? result
            : page;
        const etag = `"${result.revision}"`;
        const notModified = input.ifNoneMatch === etag;
        return {
            status: notModified ? 304 : 200,
            headers: { 'content-type': 'application/json', etag },
            body: notModified ? null : JSON.stringify(transport),
        };
    }
    catch (error) {
        const queryError = error instanceof app_base_source_query_1.AppBaseSourceQueryError ? error : null;
        const failure = {
            code: queryError?.code ?? 'APP_BASE_SOURCE_UNAVAILABLE',
            message: error instanceof Error ? error.message : input.messages.unavailable,
            ...(queryError?.details ?? {}),
        };
        return {
            status: queryError?.code === 'APP_BASE_QUERY_INVALID'
                ? 400
                : queryError?.code === 'APP_BASE_DATA_BUDGET_EXCEEDED'
                    ? 413
                    : queryError?.code === 'APP_BASE_SOURCE_UNAVAILABLE' &&
                        (0, app_base_source_query_1.isAppBaseSourceUnavailableReason)(queryError.details.reason)
                        ? 422
                        : 503,
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify(failure),
            failure,
        };
    }
}
